var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsAutomationsEventsApiRequestEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#EDF0F2",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A9AA8",
    className: "background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7c2.142 0 3.891 1.684 3.995 3.8L24 11v9c0 .042-.003.084-.008.125C25.722 20.565 27 22.134 27 24c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.866 1.278-3.434 3.007-3.876v-.007L22 20v-9c0-1.054-.816-1.918-1.85-1.995L20 9h-4c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L16 7h4zM9 4c2.21 0 4 1.79 4 4 0 1.866-1.278 3.434-3.007 3.876.004.04.007.082.007.124v15c0 .552-.448 1-1 1s-1-.448-1-1V12c0-.042.003-.084.008-.125C6.278 11.435 5 9.866 5 8c0-2.21 1.79-4 4-4zm14 18c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zM9 6c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z",
    transform: "translate(16 16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsAutomationsEventsApiRequestEvent);
export default __webpack_public_path__ + "static/media/illustrations-automations-events-api-request-event.4a2a4347.svg";
export { ForwardRef as ReactComponent };